export function captureVoucherLink() {
  const url = new URL(window.location.href);
  const token = url.searchParams.get('voucher');
  if (token && /^[a-f0-9-]{36}$/.test(token)) {
    sessionStorage.setItem('obraa.pendingVoucher', token);
    url.searchParams.delete('voucher');
    window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
  }
  return sessionStorage.getItem('obraa.pendingVoucher') || '';
}
